import { render } from "./UserMetersData.vue?vue&type=template&id=12ba435a"
import script from "./UserMetersData.vue?vue&type=script&lang=js"
export * from "./UserMetersData.vue?vue&type=script&lang=js"

import exportComponent from "/var/srv/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__